module.exports = __webpack_public_path__ + "assets/ahrefs.4345e379.svg";